export const apiUrl = "https://mmne-api.mama367.com/"
//export const apiUrl = "http://localhost:5002";
// export const apiUrl = window.ENV.API_URL;



